import React from 'react';
import { Dialog, } from '@mui/material';
import styles from '../../../../../../../custom/style.module.css';
import { 
  CustomDialogContent,
  CustomDialogTitle, 
} from '../../../../../../../custom/components';
import { CloseIconBtn, } from 'custom/constants';
import ConsigneeDetails from './ConsigneeDetails';

const ConsigneeModal = (props) => {
  const { action } = props;
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal == 'consignee'} onClose={props.onClose} maxWidth={'md'} fullWidth>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          {action == 'add' ? 'Add' : 'Edit'} Consignee
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <CustomDialogContent>
          <ConsigneeDetails {...props} fromModal={true} />
        </CustomDialogContent>
      </Dialog>
    </div>
  );
};
export default ConsigneeModal;